// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class PostAPI extends MainAPI {
	/**
	 * @param {Object} options - Option of the request
	 * @param {Number} options.breedId - Breed Id
	 * @param {('health' | 'exercise' | 'behaviour' | 'general')} options.topic - Topic
	 * @param {Number} options.offset - Offset
	 * @param {Number} options.limit - Limit
	 */
	async getPosts(options) {
		return API.get(ENDPOINTS.GET_POSTS, options);
	}

	/**
	 * @param {Number} postId
	 * @return {Object} post
	 * */
	async getPostById(postId) {
		return API.get(`${ENDPOINTS.GET_POSTS}/${postId}`)
	}

	/**
	 * @param {Number} postId - element id of the post.
	 */
	async deletePost(postId) {
		return API.delete(`${ENDPOINTS.DELETE_POST}/${postId}`);
	}
}

export default new PostAPI();
